import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('jwt');
    if (token) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <div className="w-full max-w-md px-6">
        <div className="flex flex-col items-center mb-8">
          <img src="/tini-logo.png" alt="Tini Express Logo" className="h-16 mb-4" />
          <br/>
          <p className="text-lg text-gray-700 mb-6 text-center">
          Tini Express Internal Admin Tool for customer and order management.
          </p>
        </div>

        <div className="flex flex-col items-center gap-2">
          <Link
            to="/login"
            className="w-full bg-black text-white py-2 rounded-md font-semibold hover:bg-gray-800 transition text-center"
          >
            Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Landing;
